module.exports = __webpack_public_path__ + "banquet/components/InventoryRecordListElement/images/button_heart_highlight.cfcc25d4c18eab06580104e9b43963bb.png";


//////////////////
// WEBPACK FOOTER
// ./banquet/components/InventoryRecordListElement/images/button_heart_highlight.png
// module id = 1678
// module chunks = 1